import { render } from "./LogoAnimation.vue?vue&type=template&id=8cb0fae8&scoped=true"
import script from "./LogoAnimation.vue?vue&type=script&lang=js"
export * from "./LogoAnimation.vue?vue&type=script&lang=js"

import "./LogoAnimation.vue?vue&type=style&index=0&id=8cb0fae8&scoped=true&lang=css"

import exportComponent from "/Users/timothyjoseph/Projects/simplest-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb0fae8"]])

export default __exports__